import React from 'react';
import {View} from 'react-native';
import {IValeur} from '../../../../data/types/interface/infoAssurance';
import Label from '../../Label';

interface Props {
  datas: IValeur[];
}
export const LibelleValeurs = ({datas}: Props) => {
  const form =
    datas &&
    datas.length > 0 &&
    datas.map((elt, i) => {
      return (
        <View key={i}>
          <Label title={elt.libelle} />
          <Label title={elt.valeur} />
        </View>
      );
    });

  return <View>{form}</View>;
};
